"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _defaultFilterFields = _interopRequireDefault(require("./defaultFilterFields.js"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog"));
var _style = _interopRequireDefault(require("./style.css"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var FilterBar = function FilterBar(props) {
  var fields = props.fields,
    selectedFields = props.selectedFields,
    otherFields = props.otherFields,
    onSubmit = props.onSubmit,
    renderFilters = props.renderFilters;
  var initialValues = {};
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      initialValues[field.name] = field.initialValue || '';
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _useState = (0, _react.useState)(initialValues),
    _useState2 = _slicedToArray(_useState, 2),
    previousValues = _useState2[0],
    setPreviousValues = _useState2[1];
  var actualFields = fields.filter(function (f) {
    return selectedFields.includes(f.name) && !otherFields.includes(f.name);
  }).map(function (f) {
    return _objectSpread(_objectSpread({}, _defaultFilterFields["default"][f.name]), f);
  });
  var otherFilterOptions = fields.filter(function (f) {
    return selectedFields.includes(f.name) && otherFields.includes(f.name);
  }).map(function (f) {
    return _objectSpread(_objectSpread({}, _defaultFilterFields["default"][f.name]), f);
  });
  var validateForm = function validateForm(values) {
    var errors = {};
    if (values.groupIds.length < 1) {
      errors.groupIds = "You must select at least one ".concat(props.userType === 'individuals' ? 'participant' : 'group', ".");
    }
    if (props.reportHandle && props.reportHandle === 'outcomes' && values.groupIds.length > 1) {
      errors.groupIds = "You cannot select more than one ".concat(props.userType === 'individuals' ? 'participant' : 'group', " for this report.");
    }
    if (values.startDate > values.endDate) {
      errors.startDate = 'Start Date must come before End Date';
    }
    return errors;
  };
  var setFilters = function setFilters(values) {
    setPreviousValues(values);
    onSubmit(values);
  };
  if (fields.length < 1) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: setFilters,
    validate: validateForm,
    enableReinitialize: true,
    render: function render(formProps) {
      var valueChanged = !(0, _isEqual2["default"])(formProps.values, previousValues);
      var renderDefault = function renderDefault() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].form
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].formFields
        }, actualFields.map(function (f) {
          return /*#__PURE__*/_react["default"].createElement(f.component, {
            key: f.name,
            settings: f,
            reportHandle: props.reportHandle,
            userType: props.userType
          });
        }), otherFilterOptions.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
          className: 'form-group ' + _style["default"].otherFilterBtn
        }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Other Filter Options",
          trigger: /*#__PURE__*/_react["default"].createElement("a", null, /*#__PURE__*/_react["default"].createElement(_cog["default"], {
            spaceRight: true
          }), "Other Filter Options"),
          size: "large",
          render: function render(_ref) {
            var closeModal = _ref.closeModal;
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].otherFilterOptions
            }, otherFilterOptions.map(function (f) {
              return /*#__PURE__*/_react["default"].createElement(f.component, {
                key: f.name,
                settings: f
              });
            })), /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].buttons
            }, /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-primary",
              onClick: closeModal
            }, "Close")));
          }
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "form-group  ".concat(_style["default"].generateBtn)
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn ".concat(valueChanged ? 'btn-warning' : 'btn-default ' + _style["default"].disabledBtn),
          type: "submit",
          disabled: !valueChanged
        }, valueChanged ? 'Apply Filters' : 'Filters Applied')));
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, renderFilters ? renderFilters({
        formProps: formProps,
        props: props,
        actualFields: actualFields,
        otherFilterOptions: otherFilterOptions,
        valueChanged: valueChanged,
        renderDefault: renderDefault
      }) : renderDefault());
    }
  });
};
FilterBar.propTypes = {
  fields: _propTypes["default"].array,
  selectedFields: _propTypes["default"].array,
  otherFields: _propTypes["default"].array,
  onSubmit: _propTypes["default"].func,
  reportHandle: _propTypes["default"].string,
  userType: _propTypes["default"].string,
  renderFilters: _propTypes["default"].func
};
FilterBar.defaultProps = {
  fields: {}
};
var _default = exports["default"] = FilterBar;